import { createRouter, createWebHistory, RouteLocationNormalized } from "vue-router";
import MainView from "../views/MainView.vue";
import SessionTimeout from "../components/SessionTimeout.vue";
import Results from "../views/Results.vue";
import ResultsPretty from "../components/ResultsPretty.vue";
import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import Error from "../views/Error.vue";
import LoginConfirm from "../views/LoginConfirm.vue";
import applyRoute from "./apply/apply";
import { getQuoteUrlFromFTrackingToken } from "@/services/api";
import Maintenance from "../views/Maintenance.vue";
import config from "@/config";
import { useQuoteStore } from "@/stores/quotes";
import { DEFAULT_TITLE, LOGIN_TITLE, RESULT_APPLY_TITLE, TITLE_SECONDARY } from "@/constants/pageTitles";
import { useConfigStore } from "@/stores/config";
import QuickQuoteCalculator from "../views/QuickQuoteCalculator.vue";

export const router = createRouter({
    history: createWebHistory(),
    scrollBehavior() {
        // always scroll to the top of the page when route is changed
        return { top: 0 };
    },
    routes: [
        {
            path: "/",
            name: "form",
            component: MainView,
            meta: { title: `${TITLE_SECONDARY} | ${DEFAULT_TITLE}` },
        },
        {
            path: "/sessiontimedout",
            name: "session_timeout",
            component: SessionTimeout,
            meta: { title: `${TITLE_SECONDARY} | Timeout` },
        },
        {
            path: "/results",
            name: "results",
            component: Results,
            meta: { title: RESULT_APPLY_TITLE },
            beforeEnter: async (to) => {
                const { tt: trackingToken, fromextranet: isExtranetHandoff } = to.query;

                if (isExtranetHandoff) {
                    const configStore = useConfigStore();
                    configStore.extranetHandoff = Number(isExtranetHandoff.toString()) === 1;
                }

                if (trackingToken) {
                    const res = await getQuoteUrlFromFTrackingToken(config.quoteApiUrl, trackingToken.toString());

                    if (res.success) {
                        const { quoteNumber, token } = res.data.response;

                        const quoteStore = useQuoteStore();
                        quoteStore.setToken(quoteNumber, token);

                        sessionStorage.removeItem("amsHandoffModalConfirmed");

                        return { path: to.path, query: { quotenumber: quoteNumber } };
                    }
                }
            },
        },
        {
            path: "/results-pretty",
            name: "results_pretty",
            component: ResultsPretty,
            meta: { title: RESULT_APPLY_TITLE },
        },
        ...applyRoute,
        {
            path: "/error",
            name: "error",
            component: Error,
            meta: { title: `${TITLE_SECONDARY} | Error` },
        },
        {
            path: "/login",
            name: "login",
            component: Login,
            meta: { title: `${LOGIN_TITLE}` },
        },
        {
            path: "/logout",
            name: "logout",
            component: Logout,
        },
        {
            path: "/login/confirm",
            name: "loginconfirm",
            component: LoginConfirm,
            meta: { title: `${LOGIN_TITLE}` },
        },
        {
            path: "/maintenance",
            name: "Maintenance",
            component: Maintenance,
            meta: { title: DEFAULT_TITLE },
        },
        {
            path: "/quick-quote",
            name: "quick_quote_calculator",
            component: QuickQuoteCalculator,
            meta: { title: DEFAULT_TITLE },
        },
    ],
});

export const setDocumentTitle = (to: RouteLocationNormalized) => {
    if (typeof to.meta.title === "string") {
        document.title = to.meta.title;
    } else {
        document.title = DEFAULT_TITLE;
    }
};

router.beforeEach((to) => {
    setDocumentTitle(to);
    const maintenanceMode = sessionStorage.getItem("maintenanceMode");

    if (maintenanceMode === "false") {
        return;
    }
    if (config.maintenanceMode && to.query?.maintenance === "false") {
        config.maintenanceMode = false;
        sessionStorage.setItem("maintenanceMode", "false");
        router.push({ name: to.name ?? "form" });
    } else if (config.maintenanceMode && to.name !== "Maintenance") {
        router.push({ name: "Maintenance" });
    }
});

export default router;
